export function getDateDisplay(start_date) {
  const date = new Date(start_date)
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

export const getRequestedCatererIdsFromMeta = (lead) => {
  if (lead.meta) {
    return lead.meta['requested_caterers'] || []
  }
  return []
}

export function addCatererIdToMeta(lead, catererId) {
  if (lead.meta) {
    if(lead.meta['requested_caterers']) {
      lead.meta['requested_caterers'] = lead.meta['requested_caterers'].concat(catererId)
    } else {
      lead.meta['requested_caterers'] = [catererId]
    }
  } else {
    lead.meta = {
      requested_caterers: [catererId]
    }
  }
  return lead.meta
}

export function cityNameDecorator(city_name) {
  return city_name.replace(/, USA$/, '')
}


